import api from '../../api/client';
import React from "react";
import { useSelector } from "react-redux";
import {
  Card,
  Row,
  Col,
  Avatar,
  Button,
  Progress,
  Descriptions,
  Typography,
  Tabs,
  Space,
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import config from "../../config";
import { useHistory } from "react-router-dom";
import MainCard from "../../components/Card/MainCard";

const { Title, Text } = Typography;

const Profile = () => {
  const account = useSelector((state) => state.account.user);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;
  const history = useHistory();

  const totalTasks =
    (account?.completedTasks || 0) +
    (account?.pendingTasks || 0) +
    (account?.overdueTasks || 0);

  return (
    <MainCard title="Profile Details" isOption>
      <Row gutter={16} align="middle">
        <Col>
          <Avatar
            size={80}
            src={
              account?.passport ? `/uploads/${account.passport}` : null
            }
            icon={!account?.passport && <UserOutlined />}
          />
        </Col>
        <Col>
          <Title level={4}>
            {account?.firstname} {account?.lastname}
          </Title>
          <Text type="secondary">
            {account?.is_active ? "Active" : "Inactive"}
          </Text>
        </Col>
      </Row>

      <Tabs defaultActiveKey="1" style={{ marginTop: 24 }}>
        <Tabs.TabPane tab="Personal Info" key="1">
          <Descriptions bordered column={1}>
            <Descriptions.Item label="Full Name">
              {account?.firstname} {account?.lastname}
            </Descriptions.Item>
            <Descriptions.Item label="Position">
              {account?.position || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Department">
              {account?.department || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="ID Number">
              {account?.id_number}
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {account?.email}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {account?.phone_number}
            </Descriptions.Item>
          </Descriptions>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Documents" key="2">
          <Row gutter={16}>
            {["passport", "id_card", "nhif_card", "nssf_card"].map((doc) =>
              account?.[doc] ? (
                <Col key={doc}>
                  <Space direction="vertical" align="center">
                    <Text strong>{doc.toUpperCase()}</Text>
                    <Avatar
                      src={`/uploads/${account[doc]}`}
                      shape="square"
                      size={100}
                    />
                  </Space>
                </Col>
              ) : null,
            )}
          </Row>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Task Stats" key="3">
          <div style={{ marginBottom: 16 }}>
            <Text>Completed</Text>
            <Progress
              percent={((account?.completedTasks || 0) / totalTasks) * 100}
              status="success"
            />
          </div>
          <div style={{ marginBottom: 16 }}>
            <Text>Pending</Text>
            <Progress
              percent={((account?.pendingTasks || 0) / totalTasks) * 100}
              strokeColor="#faad14"
            />
          </div>
          <div>
            <Text>Overdue</Text>
            <Progress
              percent={((account?.overdueTasks || 0) / totalTasks) * 100}
              status="exception"
            />
          </div>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Emergency Contact" key="4">
          <Descriptions bordered column={1}>
            <Descriptions.Item label="Contact Person">
              {account?.nok_firstname} {account?.nok_lastname}
            </Descriptions.Item>
            <Descriptions.Item label="Relationship">
              {account?.relatiosn || "N/A"}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {account?.nok_phone_number}
            </Descriptions.Item>
            <Descriptions.Item label="Email">
              {account?.nok_email}
            </Descriptions.Item>
          </Descriptions>
          <Button type="dashed" style={{ marginTop: 16 }}>
            Edit Contact
          </Button>
        </Tabs.TabPane>
      </Tabs>
    </MainCard>
  );
};

export default Profile;
